import React from 'react';
import Image from 'next/image';
import JobOpportunityPanel, {
  JobOpportunityType,
} from '@/components/job-opportunity-panel';
import { useIntersectionObserver } from '@/utils/site-track';
import hotIcon from '@/assets/job-title/hot.svg';

interface Props {
  data: JobOpportunityType[];
  displayName: string;
  noSwiper?: boolean;
}
const HotJobOpportunity = (props: Props) => {
  const { data, noSwiper = false } = props;
  const [hotJobOpportunities, setHotJobOpportunities] = React.useState(data);

  useIntersectionObserver(
    hotJobOpportunities.map(({ id }) =>
      document.querySelector(`[data-observer-id="${id}"]`),
    ),
  );

  React.useEffect(() => {
    if (data.length > 0) {
      setHotJobOpportunities(data);
    }
  }, [data.length]);

  return (
    <>
      <div className="font-semibold text-2xl flex items-center mb-9 tablet:mb-6">
        <Image
          src={hotIcon}
          alt="job opportunity icon"
          width={24}
          height={24}
        />
        <h2 className="ml-2 opacity-85">热招职位</h2>
      </div>
      <JobOpportunityPanel
        data={data}
        noSwiper={noSwiper}
        slideClassName="grid gap-x-4 gap-y-6 grid-rows-4 grid-cols-1 tablet:grid-cols-4 tablet:grid-rows-3"
      />
    </>
  );
};

export default HotJobOpportunity;
